export const QRPaymentName: any = {
    "0215566010596": "บจก.APC 1984 จำกัด",
    "0465567000754": "บจก.ดาภิรักษ์ เมจิก ดีไซน์",
    // "0115566029182": "บจก.LRV 1960 จำกัด"
}